import React from "react";
import { useSettings } from "@/contexts/SettingsContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const { settings } = useSettings();
  const phone = (settings.socials?.whatsapp || "").replace(/\D/g, "");
  if (!phone) return null;
  const url = `https://wa.me/${phone}?text=${encodeURIComponent("Hi Mostash — I saw your portfolio and wanted to say hello.")}`;
  return (
    <a
      data-testid="whatsapp-cta"
      href={url}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-5 left-1/2 -translate-x-1/2 md:left-auto md:right-8 md:translate-x-0 z-40 btn-pill btn-primary shadow-2xl shadow-black/50"
    >
      <MessageCircle size={16} />
      <span>Talk to us on WhatsApp</span>
    </a>
  );
}
